import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpHeaders,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { map, catchError, tap } from 'rxjs/operators';
import { delay } from 'q';
import { AuthService } from './app/core/authentication/auth.service';
import { AuthKey } from './app/data/auth-key.enum';
import { AlertService } from './app/core/alert/alert.service';
@Injectable()

export class TokenInterceptor implements HttpInterceptor {
    constructor(public auth: AuthService, private alert: AlertService, private router: Router) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let token = localStorage.getItem(AuthKey.ANON_TOKEN);
        if (!!token) {
            if (!request.url.includes('thumbnails')) {
                const cloned = request.clone({
                    // headers: request.headers.set('Authorization', this.auth.getToken())
                    headers: new HttpHeaders({
                        'Access-Control-Allow-Origin': '/*',
                        'Authorization': token,
                        'device': 'Web'
                    })
                });
                // console.log("request: ", cloned)
                return next.handle(cloned).pipe(
                    tap(event => {
                        if (event instanceof HttpResponse) {

                        }
                    }, error => {
                        if (error.status == 401) {
                            this.alert.error("Bir hata oluştu. Lütfen sayfayı yenileyiniz.");
                        }
                    })
                )
            }
            
            return next.handle(request);
        }
        else {
            return next.handle(request);
        }
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/httpconfig.interceptor.ts